class LayoutService {

  protected mimityStylesheet: HTMLLinkElement;
  protected adminStylesheet: HTMLLinkElement;
  protected bodyElement: HTMLBodyElement;

  constructor() {
    this.mimityStylesheet = document.getElementById('mimity-stylesheet')! as HTMLLinkElement;
    this.adminStylesheet  = document.getElementById('admin-stylesheet')! as HTMLLinkElement;
    this.bodyElement      = document.body as HTMLBodyElement;
  }

  public admin(): void {
    this.deactivateMimity();
    this.activateAdmin();
  }

  public mimity(): void {
    this.deactivateAdmin();
    this.activateMimity();
  }

  protected activateMimity(): void {
    this.mimityStylesheet.disabled = false;
    this.bodyElement.classList.add('mimity');
  }

  protected deactivateMimity(): void {
    this.mimityStylesheet.disabled = true;
    this.bodyElement.classList.remove('mimity');
  }

  protected activateAdmin(): void {
    this.adminStylesheet.disabled = false;
    this.bodyElement.classList.add('admin');
  }

  protected deactivateAdmin(): void {
    this.adminStylesheet.disabled = true;
    this.bodyElement.classList.remove('admin');
  }
}

export default new LayoutService();
